import React, { useState } from "react";
import Api_Instance from "../../../api/Api_Instance";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { RaiseFunds } from "../../../api/endpoints";
import ErrorMessage from "../../../common/errormsg/ErrorMessage";
import CountriesApi from "../../../common/countriesapi/CountriesApi";
import { emojiPattern, multipleDomainsPattern } from "../../../utils/Utils";

function RaiseFund() {
  const api = Api_Instance.unAuth();
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone: "",
    company_name: "",
    country: "",
    state: "",
    city: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [countrydata, setCountrydata] = useState({
    countryid: "",
    stateid: "",
    cityid: "",
  });
  const { useCountries, States, Ctiy } = CountriesApi;
  const { countries } = useCountries();
  const { statedata } = States(countrydata.countryid);
  const { citydata } = Ctiy(countrydata.stateid);

  const handleCountryChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selectedCountryName = options[selectedIndex].text;
    setFormValues((prevValues) => ({
      ...prevValues,
      country: value,
    }));
    setCountrydata((prev) => ({
      ...prev,
      countryid: selectedIndex - 1,
    }));
  };

  const handleStateChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selected_id = options[selectedIndex].getAttribute("data-id");
    setFormValues((prevValues) => ({
      ...prevValues,
      state: value,
    }));
    setCountrydata((prev) => ({
      ...prev,
      stateid: selected_id,
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const validationErrors = validate({
      ...formValues,
      [name]: value,
    });
    setErrors(validationErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedValues = {};
    Object.keys(formValues).forEach((key) => {
      trimmedValues[key] = formValues[key].trim();
    });

    try {
      const validationErrors = validate(formValues);
      setErrors(validationErrors);
      if (Object.keys(validationErrors).length === 0) {
        const res = await api("POST", RaiseFunds.POST_RAISE_FUND, trimmedValues);
        if (res.status) {
          setFormValues({
            name: "",
            email: "",
            phone: "",
            company_name: "",
            country: "",
            state: "",
            city: "",
            message: "",
          });
          toast.success(res.data.message || "Successfully Create");
          navigate("/");
        }
      }
    } catch (error) {
      toast.error(error.message || "invalid data");
    }
  };

  const validate = (values) => {
    const errors = {};
    const requiredFields = [
      "name",
      "email",
      "phone",
      "company_name",
      "country",
      "state",
      "city",
      "message",
    ];

    requiredFields.forEach((field) => {
      const value = values[field];
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        let displayName = field.charAt(0).toUpperCase() + field.slice(1);
        if (field === "company_name") {
          displayName = "Company name";
        }
        errors[field] = `${displayName} is required`;
      }
    });

    if (values.email && !/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = "Email address is invalid";
    } else if (emojiPattern.test(values.email)) {

    } else if (multipleDomainsPattern.test(values.email)) {
      errors.email = "Email address not contain multidomain";
    }
    if (values.phone && !/^[6-9]\d{9}$/.test(values.phone)) {
      errors.phone = "Mobile No is invalid";
    }

    return errors;
  };
  return (
    <div>

      <div className="w-full max-w-[1250px]  mx-auto mt-5 p-2">
        <h1 className="text-start font-bold text-4xl mb-2 text-slate-400">
          Raise <span className="text-secondaryColor">Funds</span>
        </h1>
        <hr className="mt-4" />
      </div>
      <div class="w-full max-w-[1250px] flex flex-col md:flex-row mx-auto mt-3 bg-white justify-between">
        <div class=" bg-[#fafafa] w-full lg:w-[70%] p-2 rounded-lg p-3 border">
          <p>
            Fundraising is indispensable for the continuance and advancement of
            non-profit and charitable organizations. Fundraising campaigns are
            the fundamental focus of these organizations. It is so caused in
            absence of performing capital these organizations cannot extend
            services essential to reach their goals. When the digital market had
            not cropped up funds were mostly gathered through donations. The
            money thus collected is used to fund programs, pay expenses, etc.
          </p>
          <h2 class="text-2xl mt-4">Fund Collection</h2>
          <ul class="list-disc ml-6 mt-2">
            <li>
              Boost brand recognition-due to elevated competition and
              diminishing attention spans brand knowledge becomes necessary.
            </li>
            <li>
              Motivate voided doners-those doners who have made single
              contribution should be persuaded to make recurring donations as
              urgent work.
            </li>
          </ul>
          <p class="mt-4">
            Your distinct fundraising goal will decide the method you convey the
            message through supports. The message conveyed will differ from case
            to case. In case you are going to approach the repeat donors the
            communication letter will be different compared to if you wish to
            secure one-time gifts. Break down the fundraising goals in stages
            and method of reaching it. Complete the task related to it through
            the cooperation of supports. All this should be done meticulously
            only then the tasks will be achieved.
          </p>
          <p class="mt-4">
            Your distinct fundraising goal will decide the method you convey the
            message through supports. The message conveyed will differ from case
            to case. In case you are going to approach the repeat donors the
            communication letter will be different compared to if you wish to
            secure one-time gifts. Break down the fundraising goals in stages
            and method of reaching it. Complete the task related to it through
            the cooperation of supports. All this should be done meticulously
            only then the tasks will be achieved.
          </p>
        </div>
        <div class="px-2 lg:w-[27%]">
          <form class="bg-card_bg_color border p-4 rounded-md" onSubmit={handleSubmit}>
            <div class="mb-3">
              <label
                class="block text-sm font-semibold mb-2"
                for="name"
              >
                Name<span className="text-star_color">*</span>
              </label>
              <input
                class=" appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                name="name"
                value={formValues.name}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter Name"
                maxLength={30}
              />
              {errors.name && <ErrorMessage error={errors.name} />}
            </div>
            <div class="mb-3">
              <label
                class="block text-sm font-semibold mb-2"
                for="email"
              >
                Email<span className="text-star_color">*</span>
              </label>
              <input
                class=" appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="email"
                type="email"
                name="email"
                value={formValues.email}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter Email"
              />
              {errors.email && <ErrorMessage error={errors.email} />}
            </div>
            <div class="mb-3">
              <label
                class="block text-sm font-semibold mb-2"
                for="mobile"
              >
                Mobile No.<span className="text-star_color">*</span>
              </label>
              <input
                class=" appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="mobile"
                type="text"
                name="phone"
                value={formValues.phone}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter Mobile Number"
              />
              {errors.phone && <ErrorMessage error={errors.phone} />}
            </div>
            <div class="mb-3">
              <label
                class="block text-gray-700 text-sm font-semibold mb-2"
                for="company"
              >
                Company Name <span className="text-star_color">*</span>
              </label>
              <input
                class=" appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="company"
                type="text"
                name="company_name"
                value={formValues.company_name}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter Company Name"
              />
              {errors.company_name && (
                <ErrorMessage error={errors.company_name} />
              )}
            </div>

            <div className="mb-3">
              <label
                htmlFor="country"
                className="block text-gray-700 text-sm font-semibold mb-2"
              >
                Country <span className="text-star_color">*</span>
              </label>
              <select
                id="country"
                name="country"
                value={formValues.country}
                onChange={handleCountryChange}
                onBlur={handleBlur}
                class="border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              >
                <option value="" disabled>
                  Select Country
                </option>
                {countries?.map((item) => (
                  <option value={item.name}>{item.name}</option>
                ))}
              </select>

              {errors.country && <ErrorMessage error={errors.country} />}
            </div>
            <div className="mb-3">
              <label
                htmlFor="state"
                className="block text-gray-700 text-sm font-semibold mb-2"
              >
                State <span className="text-star_color">*</span>
              </label>
              <select
                id="state"
                name="state"
                value={formValues.state}
                onChange={handleStateChange}
                onBlur={handleBlur}
                class="border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              >
                <option value="" disabled>
                  Select State
                </option>
                {statedata?.map((item) => (
                  <option value={item.name} data-id={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>

              {errors.state && <ErrorMessage error={errors.state} />}
            </div>
            <div className="mb-3">
              <label
                htmlFor="city"
                className="block text-gray-700 text-sm font-semibold mb-2"
              >
                Select City<span className="text-star_color">*</span>
              </label>
              <select
                id="city"
                name="city"
                value={formValues.city}
                onChange={(e) => {
                  handleChange(e);
                }}
                onBlur={handleBlur}
                class="border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              >
                <option value="" disabled>
                  city
                </option>
                {citydata?.map((item) => (
                  <option value={item.name}>{item.name}</option>
                ))}
              </select>

              {errors.city && <ErrorMessage error={errors.city} />}
            </div>
            <div class="mb-4">
              <label
                class="block text-gray-700 text-sm font-semibold mb-2"
                for="message"
              >
                Message<span className="text-star_color">*</span>
              </label>
              <textarea
                class="border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="message"
                rows="4"
                name="message"
                value={formValues.message}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter Your Message"
                maxLength={250}
                minLength={20}
              ></textarea>
              {errors.message && <ErrorMessage error={errors.message} />}
            </div>
            <div class="flex ">
              <button
                class="bg-primaryColor hover:bg-blue-700 text-white font-bold py-2 px-4 w-full rounded focus:outline-none focus:shadow-outline"
                type="submit"
              >
                Apply
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default RaiseFund;
